.container {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding-left: var(--page-padding);
    padding-right: var(--page-padding);
}

.container:first-of-type {
    padding-top: 40px;

}